import { 
    getStepCols, 
    FilterSection, 
    SelectionSection,
} from "../shared";

import { StableSelect } from "../../../../components/SharedComponents/sharedComponents.index";

import { HistoricalAnalysis } from "./components/HistoricalAnalysis";

export const HistoricalTab = ({ actions, ctx, uiState }) => {

  const { 
    setHistoricalFilters, 
    clearHistoricalFilters, 
    setSelectedType,
    setDetailedMatrixSeason
  } = actions || {};

  const { 
    filterOptions, 
    types, 
    indicatorData, 
    tenantHierarchy,
    detailedMatrixSeasonsOptions,
  } = ctx || {};

  const { 
    historicalFilters, 
    detailedMatrixSeason, 
    selectedType = false,
    userSelectedTypeId
  } = uiState || {};
  
  const cols = getStepCols(true, !!selectedType);

  const isTypeSelected = (item, selected) => {
    if (!userSelectedTypeId) return false;
    return item.attributePerformanceMatrixAggregationId === userSelectedTypeId;
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12, flex: 1, minHeight: 0 }}>
      <section style={{ 
        backgroundColor: "#fff", border: "1px solid #e5e5e5", borderRadius: "12px", 
        boxShadow: "0 1px 3px rgba(0,0,0,0.04)", overflow: "hidden",
        padding: "16px 20px", display: 'flex', alignItems: 'center', justifyContent: 'space-between'
      }}>
        <hgroup style={{ display: 'flex', flexDirection: 'column' }}>
          <h4 style={{ fontSize: "16px", fontWeight: "700", color: "#1a1a1a" }}>
            Análise Histórica
          </h4>

          <p style={{ fontSize: "12px", color: "#aaa", marginTop: 2 }}>
            Análise de performance histórica por tipo de produto
          </p>
        </hgroup>

        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          <StableSelect
            label=""
            mode="rovitex"
            value={detailedMatrixSeason}
            onChange={setDetailedMatrixSeason}
            options={detailedMatrixSeasonsOptions}/>
        </div>
      </section>

      <div style={{ display: "grid", gridTemplateColumns: cols, gap: "12px", flex: 1, minHeight: 0 }}>
        <FilterSection
          actions={{ setFilters: setHistoricalFilters, clearFilters: clearHistoricalFilters }}
          ctx={{ filterOptions: filterOptions }}
          uiState={{ filters: historicalFilters, total: filterOptions?.hierarquia?.Tipo.length }}/>

        <SelectionSection
          actions={{ onSelect: setSelectedType }}
          ctx={{
            items: types,
            title: "Selecione o Tipo",
            isSelected: isTypeSelected,
          }}
          uiState={{ selectedItem: selectedType }}/>

        {!!selectedType && (
          <HistoricalAnalysis
            ctx={{ 
              indicatorData: indicatorData, 
              tenantHierarchy: tenantHierarchy,
              selectedType: selectedType
            }}/>
        )}
      </div>
    </div>
  );
};